import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/account")({
	component: AccountRoute,
});

function AccountRoute() {
	// Any authenticated user can manage their own account. Layout comes from the parent
	// _authenticated route (shared, persistent); the account nav shows in that layout's
	// sidebar (see side-nav.tsx). This route only nests.
	return <Outlet />;
}
